import { inject, Service } from '@angular/core';
import { MngActionDef } from '@mng/mng-inputs';
import { Action, State, StateContext } from '@ngxs/store';
import { Title } from '@angular/platform-browser';
import { Partner } from '@mng/domain';

export interface IUiActiveArea {
  title?: string;
}

export interface IFrameState {
  activeArea?: IUiActiveArea;
  sidenavActionDefs?: MngActionDef[];
  rightSidenavEnabled?: boolean;
  activePartner?: Partner;
}

export interface IFrameAppState {
  frame?: IFrameState;
}

export class SetActiveArea {
  static type = '[Frame] SetActiveArea';

  constructor(public payload: IUiActiveArea) {}
}

export class SetSidenavActionDefs {
  static type = '[Frame] SetGlobalActionDefs';

  constructor(public payload: MngActionDef[]) {}
}

export class SetRightSidenavEnabled {
  static type = '[Frame] SetRightSidenav';

  constructor(public payload: boolean) {}
}

export class SetActivePartner {
  static type = '[Frame] SetActivePartner';

  constructor(public payload: Partner) {}
}

@State<IFrameState>({
  name: 'frame',
  defaults: {
    rightSidenavEnabled: false,
    sidenavActionDefs: [],
    activeArea: { title: '' }
  }
})
@Service()
export class FrameState {
  private titleService = inject(Title);

  @Action(SetActiveArea)
  setActiveArea({ getState, setState, patchState }: StateContext<IFrameState>, { payload }: SetActiveArea) {
    this.titleService.setTitle(payload.title);
    setState({ ...getState(), ...{ activeArea: payload } });
  }

  @Action(SetSidenavActionDefs)
  setGlobalActionDefs(
    { getState, setState, patchState }: StateContext<IFrameState>,
    { payload }: SetSidenavActionDefs
  ) {
    setState({ ...getState(), sidenavActionDefs: [...(payload || [])] });
  }

  @Action(SetRightSidenavEnabled)
  setRightSidenavEnabled(
    { getState, setState, patchState }: StateContext<IFrameState>,
    { payload }: SetRightSidenavEnabled
  ) {
    setState({ ...getState(), rightSidenavEnabled: payload });
  }

  @Action(SetActivePartner)
  setActivePartner({ getState, setState, patchState }: StateContext<IFrameState>, { payload }: SetActivePartner) {
    setState({ ...getState(), activePartner: payload });
  }
}

export function getActiveArea(state: IFrameAppState): IUiActiveArea {
  return state.frame.activeArea;
}

export function getSidenavActionDefs(state: IFrameAppState): MngActionDef[] {
  return state.frame.sidenavActionDefs;
}

export function getRightSidenavEnabled(state: IFrameAppState): boolean {
  return state.frame.rightSidenavEnabled;
}

export function getActivePartner(state: IFrameAppState): Partner | undefined {
  return state.frame.activePartner;
}
